import { IDocumentBlock } from "@/lib/types";
import React from "react";
import { StackSimple } from "@phosphor-icons/react";

interface UserDocumentProps {
    document: IDocumentBlock;
}

export const UserDocument = ({ document }: UserDocumentProps) => {
    return (
        <div className={"flex flex-row items-start bg-blue-200 rounded-xl py-2 px-4 mb-4"}>
            <div className={"pr-2"}>
                <StackSimple size={24} />
            </div>
            <div className={"text-sm"}>{document.name}</div>
        </div>
    );
};
